export const useActionCheckNeedRefreshProfiling = () => {
  const { onPlay, complete } = useAbstractAction(
    'actionCheckNeedRefreshProfiling',
    true
  );

  const profile = useProfileStore();

  const route = useRoute();

  const dialogRefreshProfiling = useDialogRefreshProfiling();

  dialogRefreshProfiling.onCancel(() => {
    complete();
  });

  onPlay(async () => {
    if (profile.needToRefreshProfiling) {
      if (profile.refreshProfiling.htmlMessage) {
        dialogRefreshProfiling.open();
      } else {
        return navigateTo('/profiling/by-step?continue=' + route.fullPath);
      }
    } else {
      complete();
    }
  });
};
